module.exports = __webpack_public_path__ + "img/0Q3A7263_L_WoodMatted_MockedUp.4a027f4e.jpg";